<template>
  <div id="app" :class="'cid-' + CID">
    <!-- @TODO App loading div -->
    <transition name="fade" enter-active-class="fade-enter-active" leave-active-class="fade-leave-active">
      <LoadingSpinner v-if="!dataLoaded && featureSet.loadingSpinner.logoImg" type="logo"/>
      <LoadingSpinner v-if="!dataLoaded && featureSet.loadingSpinner.logoSVG" type="svg"/>
      <!-- Main router view for the main MainPage component -->
      <router-view v-if="dataLoaded"></router-view>
    </transition>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import staticDataLoaderMixin from './store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from './store/modules/contentData/content-data-loader';
import LoadingSpinner from './components/LoadingSpinner.vue';

export default {
	name: 'App',
	components: {
		LoadingSpinner,
	},
	mixins: [staticDataLoaderMixin, contentDataLoaderMixin, featureSetLoaderMixin],
	computed: {
		...mapState('title', ['title']),
		dataLoaded() {
			document.title = this.title ? this.title : this.$store.state.cName;
			return this.dataAvailable && this.contentAvailable;
		},
		CID() {
			return this.$store.state.CID;
		},
	},
};
</script>


<style src="@/styles/app.less" lang="less"></style>
